import styled from '@emotion/styled';
import { Checkbox, Tooltip } from 'antd';
import FormField from 'components/FormField';
import { set, uniq } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { PolicyFormValues, Question, useShippingStatusLabel, Validate } from './share';
import { DisabledProps } from '../TaskForm/share';

const TooltipList = styled.ul`
  padding-left: 10px;
  margin-bottom: 0;
`;

type FV = Pick<PolicyFormValues, 'cancelTradeConfig'>;

export const validate: Validate = (errors, values, t) => {
  const { cancelTradeConfig: { shippingStatus = [] } = {} } = values;

  if (shippingStatus.length === 0) {
    set(errors, 'cancelTradeConfig.shippingStatus', t('aide.请选择出货进度'));
  }
};

function ShippingStatusField({ disabled }: DisabledProps) {
  const { t } = useTranslate();

  const shippingStatusList: Marketing.ShippingStatus[] = ['TO_PROCESS', 'PROCESSED'];

  const statusLabelMap = useShippingStatusLabel();

  return (
    <FormField<Required<FV>['cancelTradeConfig']['shippingStatus']>
      required
      name="cancelTradeConfig.shippingStatus"
      label={
        <div>
          {t('aide.出货进度')}
          <Tooltip
            title={
              <TooltipList>
                <li>{`${statusLabelMap.TO_PROCESS}：${t('aide.处理中的说明')}`}</li>
                <li>{`${statusLabelMap.PROCESSED}：${t('aide.已处理的说明')}`}</li>
              </TooltipList>
            }
          >
            <Question />
          </Tooltip>
        </div>
      }
    >
      {({ field: { value = [], onChange, onBlur } }) => {
        const isChecked = (status: Marketing.ShippingStatus) => value.includes(status);

        const onCheckedChange = (checked: boolean, status: Marketing.ShippingStatus) => {
          onBlur();

          onChange(checked ? uniq([...value, status]) : value.filter((item) => item !== status));
        };

        return shippingStatusList.map((status) => {
          return (
            <Checkbox
              disabled={disabled}
              checked={isChecked(status)}
              onChange={({ target: { checked } }) => onCheckedChange(checked, status)}
            >
              {statusLabelMap[status]}
            </Checkbox>
          );
        });
      }}
    </FormField>
  );
}

export default ShippingStatusField;
